require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-automotive-the-digital-battleground.json") })
        }
      }, "path---news-automotive-the-digital-battleground");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-automotive-the-digital-battleground!./.cache/json/news-automotive-the-digital-battleground.json
// module id = 1418
// module chunks = 231608221292675